import createFocusPlugin from '@draft-js-plugins/focus';
import styles from './focus.module.less';
export const focusPlugin = createFocusPlugin({
    theme: {
        focused: styles.focused,
        unfocused: styles.unfocused,
    },
});
